export default __webpack_public_path__ + "static/media/platformerProto.8996a7f9.gif";